var _defs, _polygon, _polygon2, _polygon3, _polygon4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { memo } from "react";
var SvgLogoTransfixGradient = function SvgLogoTransfixGradient(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 847.6 172.71",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#radial-gradient);\n      }\n      .cls-2 {\n        fill: url(#radial-gradient-2);\n      }\n      .cls-3 {\n        fill: url(#radial-gradient-3);\n      }\n      .cls-4 {\n        fill: url(#radial-gradient-4);\n      }\n    "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 826.73,
    cy: 17.42,
    r: 80.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 826.66,
    cy: 17.34,
    r: 80.3,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 826.93,
    cy: 17.34,
    r: 80.04,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 826.83,
    cy: 17.38,
    r: 80.35,
    xlinkHref: "#radial-gradient"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "791.32 0 846.8 0 798.94 36.59 743.41 36.59 791.32 0"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "802.11 38.44 802.11 97.56 830.12 76.67 830.12 17.14 802.11 38.44"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "833.63 14.41 847.59 3.89 847.6 20.06 833.63 30.61 833.63 14.41"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "833.63 34.96 847.6 24.45 847.6 41.23 833.63 51.77 833.63 34.96"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.16,169.91l0-99.48h-34L3.47,57l96.22,0V70.42H58.57l0,99.48Z",
    transform: "translate(-3.47 -4.15)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M117.18,169.9l0-112.93h48.32a36.43,36.43,0,0,1,36.38,36.37h0a36.64,36.64,0,0,1-30.48,36l38.31,40.57H191.32l-50.71-53.41h24.87a22.74,22.74,0,0,0,16.21-6.75A23.05,23.05,0,0,0,165.47,70.4H130.59l0,99.49Z",
    transform: "translate(-3.47 -4.15)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M216.26,169.88,268.38,56.66l52.17,113.19H305.63l-.2-.44L268.38,88.86l-37.4,81Z",
    transform: "translate(-3.47 -4.15)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M431.94,176.85,351,90.46l0,79.39H337.58l0-114.64,80.93,86.39V78.12l.1-21.84,13.33.06Z",
    transform: "translate(-3.47 -4.15)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M462.41,169.82l-7.69-13.43,55.12,0a18.2,18.2,0,0,0,0-36.39h-29a31.57,31.57,0,0,1-22.29-53.81,31.15,31.15,0,0,1,22.28-9.27l47.43,0,7.68,13.44H480.82a18.11,18.11,0,0,0,0,36.21h29a31.66,31.66,0,0,1,22.29,53.93,31.12,31.12,0,0,1-22.28,9.34Z",
    transform: "translate(-3.47 -4.15)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M558.75,169.8l0-112.92,75.65,0,7.69,13.44h-69.9V106.9H634.4l7.68,13.44H572.17l0,49.46Z",
    transform: "translate(-3.47 -4.15)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M659,169.78l0-112.92h13.43l0,112.93Z",
    transform: "translate(-3.47 -4.15)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M689.13,169.77l43-56.47-43-56.45H706l34.7,45.36,34.49-45.38H792L749,113.3l43,56.45H775.16l-34.51-45.36L706,169.77Z",
    transform: "translate(-3.47 -4.15)"
  })));
};
var Memo = /*#__PURE__*/memo(SvgLogoTransfixGradient);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "transfix-ui/components/LogoTransfix/svgs/LogoTransfixGradient.52c906146654c5db70f79c0bd52bd5ef.svg";